<!--
 * @Description:市场营销-线索管理联系人，投放记录联系人  props edisabled 不可以编辑
   /zbu/clueTracking/view 线索跟踪详情
   /zbu/clueReleaseRecord/view 线索投放记录详情
   /zbu/partnerContact/view 线索管理列表详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-09-27 18:43:36
 * @LastEditors: cxh
-->
<template>
  <cos-modal
    v-model:visible="visible"
    :title="view ? '查看' : form.id ? '编辑活动' : '新增活动'"
    class="clueMerge"
    width="670px"
    @ok="handleSubmit"
    :hideOk="view"
    :confirmLoading="loading"
  >
    <CosViewContent :view="view">
      <a-form :model="form" ref="formRef" v-if="visible">
        <a-form-item
          name="name"
          :rules="{
            required: true,
            message: '请输入'
          }"
          label="活动名称"
        >
          <CosInput v-model:value="form.name" placeholder="请输入" :disabled="view" :view="view" />
        </a-form-item>
        <a-form-item name="startTime" label="活动时间">
          <cos-range-picker
            v-model:startTime="form.startTime"
            v-model:endTime="form.endTime"
            :disabled="view"
            :view="view"
          />
        </a-form-item>
        <a-form-item
          name="cost"
          :rules="{
            required: true,
            message: '请输入'
          }"
          label="活动费用"
        >
          <CosInputNumber
            v-model:value="form.cost"
            :min="0"
            :maxlength="15"
            placeholder="请输入"
            :disabled="view"
            :view="view"
          />
        </a-form-item>
        <a-form-item
          label="是否参加"
          name="joinFlag"
          :rules="[{ required: true, validator: selectForNumberValidate, message: '请选择' }]"
        >
          <CosSelect
            v-model:value="form.joinFlag"
            allowClear
            placeholder="请选择"
            :options="dataConfig.joinFlag"
            :view="view"
            :disabled="view"
          />
        </a-form-item>
        <a-form-item name="resultEvaluate" label="活动区域">
          <CustomerArea v-model:value="form.areaId" v-model:label="form.areaName" :view="view" :disabled="view" />
        </a-form-item>
        <a-form-item label="活动效果评估" :span="24">
          <CosTextarea v-model:value="form.resultEvaluate" placeholder="请输入" :view="view" :disabled="view" />
        </a-form-item>
      </a-form>
    </CosViewContent>
  </cos-modal>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import { partnerActivityAdd, partnerActivityEdit } from '@/api/marketing/marketingManage'
import type { PartnerManage } from '@/typings/api/marketingManage'
import CustomerArea from '@/components/CustomerArea'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
import { selectForNumberValidate } from '@/utils/validate'
import { cloneDeep } from 'lodash-es'
const emit = defineEmits(['success'])
defineProps({
  view: {
    type: Boolean
  }
})
const formRef = ref()
const loading = ref(false)
const visible = ref(false)
const form = ref<PartnerManage['partnerContact']>({})
const toggle = (row?: PartnerManage['partnerContact']) => {
  if (row) {
    form.value = cloneDeep(row)
  } else {
    form.value = {}
  }
  visible.value = !visible.value
}
defineExpose({
  toggle
})
// 新增编辑提交
const handleSubmit = () => {
  formRef.value.validate().then(async () => {
    loading.value = true
    try {
      const { partnerName, ...other } = form.value
      if (form.value.id) {
        await partnerActivityEdit(other)
        message.success('编辑成功')
        emit('success')
      } else {
        await partnerActivityAdd(other)
        message.success('新增成功')
        emit('success', 'add')
      }
      toggle()
    } catch (error) {}
    loading.value = false
  })
}
</script>
<script lang="ts">
export default { name: 'partnerActivityFrom' }
</script>
<style lang="scss" scoped></style>
